import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['star']

  connect() {
    this.selectedIndex = 0
    this.currentIndex = 0
    this.activeClass = 'text-yellow-200'
    this.inactiveClass = 'text-gray-200'
    this.drawStars()
  }

  showHover(e) {
    this.currentIndex = e.currentTarget.dataset.index
    this.drawStars()
  }

  hideHover() {
    this.currentIndex = this.selectedIndex || 0
    this.drawStars()
  }

  selectRating(e) {
    this.selectedIndex = e.currentTarget.dataset.index
  }

  drawStars() {
    for(let i = 0; i < this.starTargets.length; i++) {
      if (i <= this.currentIndex - 1) {
        this.starTargets[i].classList.add(this.activeClass)
        this.starTargets[i].classList.remove(this.inactiveClass)
      } else {
        this.starTargets[i].classList.add(this.inactiveClass)
        this.starTargets[i].classList.remove(this.activeClass)
      }
    }
  }
}
